import { ofType } from 'redux-observable';
import { of, from, throwError } from 'rxjs';
import { mergeMap, map, catchError, tap, concatMap } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { defaultErrorDuration } from 'web-app/react/global-event/helpers/constants';
import translate from 'signin-app/helpers/translate';
import { saveLoginData, saveAccessToken, removeLoginData, getDeviceId } from 'signin-app/api/helpers/local-storage';
import { client } from 'signin-app/api/clients/apollo-client';
import * as Actions from './actions';
import * as Queries from './queries';
const getSiteId = () => {
    return from(client.query({
        query: Queries.GetSiteId,
        fetchPolicy: 'network-only',
    })).pipe(mergeMap(({ data }) => {
        return of(data === null || data === void 0 ? void 0 : data.institutions[0].institutionId);
    }), catchError(() => {
        return of('');
    }));
};
const isQrSigninAvailable = (siteId) => {
    return from(client.query({
        query: Queries.GetQRSignInSettings,
        variables: {
            siteIds: [siteId],
        },
        fetchPolicy: 'network-only',
    })).pipe(mergeMap(({ data }) => {
        return of(data === null || data === void 0 ? void 0 : data.qrSignin.siteSettings.siteSettings[0].isEnabled); // The sign in user has one institution id only
    }), catchError(() => {
        return of(false);
    }));
};
const authenticate = (password) => {
    return from(client.mutate({
        mutation: Queries.Login,
        variables: {
            password,
            deviceId: getDeviceId(),
        },
    })).pipe(mergeMap(({ data }) => {
        if (data) {
            return of(data.signIn.authenticate);
        }
        else {
            return throwError('Authentication failed');
        }
    }));
};
const login = action$ => action$.pipe(ofType(Actions.login.type), mergeMap(({ payload }) => authenticate(payload.password).pipe(tap(response => saveAccessToken(response.accessToken)), mergeMap(response => {
    return getSiteId().pipe(mergeMap(siteId => {
        return isQrSigninAvailable(siteId).pipe(tap(isQrSigninEnabled => saveLoginData(response.isPinAvailable, isQrSigninEnabled, siteId, response.deviceId)), map(isQrSigninEnabled => {
            return Actions.loginSuccess.action(response.accessToken, response.isPinAvailable, isQrSigninEnabled, siteId, response.deviceId);
        }));
    }));
}), catchError(e => {
    dispatchStatusMessageEvent({
        message: translate('invalidPassword'),
        statusType: 'Error',
        sticky: false,
        e2eId: '',
        duration: defaultErrorDuration,
    });
    return of(Actions.loginFailed.action(e));
}))));
const logout = action$ => action$.pipe(ofType(Actions.logOut.type), concatMap(() => {
    return of(Actions.logOutSuccess.action());
}), concatMap(logOutSuccessAction => {
    // After Actions.logOutSuccess.action() completes, remove login data
    removeLoginData();
    return of(logOutSuccessAction);
}));
export default combineEpics(login, logout);
